import { HostListener, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login/login.service';
import Swal from 'sweetalert2';
import { ProductData } from '../../core/model/Product.model';

@Injectable({
  providedIn: 'root'
})
export class SwalService {
  innerWidth: number;

  @HostListener('window-resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }
  constructor(
    private router: Router,
    private login: LoginService
  ) { }

  // este SWAL es para mostrar que no hay suficiente existencia
  public SwalMessesExistencia = (existencia): void => {
    Swal.fire({
      type: 'info',
      title: 'Añadir a la cesta',
      text: 'Existencias insuficientes. No puedes agregar más de ' + (existencia === '.000' ? '0' : existencia) + (existencia !== 1 ? ' artículos' : ' artículo'),
      confirmButtonText: 'Aceptar',
      footer: '<span style="color: #666">La existencia de este artículo es de ' + (existencia === '.000' ? '0' : existencia) + ' pzs.</span>'
    });
  }

  // esta función es para retornar el precio de un artículo
  private getPrices = (data: ProductData): string | number => {
    const precio = data.PrecioNormal > data.PrecioVenta || data.PrecioVenta !== null ? data.PrecioVenta : data.PrecioNormal;
    const dataUser = this.login.getDataClientePedido();
    if (this.login.isLogged()) {
      return dataUser.allow_prices === 'SI' ? dataUser.es_publicogeneral === 'SI' ? '$' + Number(precio * 1.16).toFixed(2) : '$' + Number(precio).toFixed(2) : '<span class="no-permisos">No tienes permisos para ver precios</span>';
    } else {
      return '$' + Number(precio * 1.16).toFixed(2);
    }
  }

  // este SWAL es para mostrar que el artículo se agrego a la cesta
  public swalMessesAddCartSuccess = (data: ProductData, cantidad: number) => {
    let html2 = '<div class="row cart-popup d-flex justify-content-center">' +
      '<div class="col-4">' +
      '<img src="' + data?.Img + '"' +
      '' +
      ' class="img-responsive" alt="' + data.ClaveArticulo +
      '" fallimg>' +
      '</div>' +
      '<div class="col-8 text-1rem">' +
      '<p class="text-left m-0"><span>' + data.Descripcion +
      '</span></p> <br>' +
      '<p class="text-left m-0 "><span>Clave: </span>' + data.ClaveArticulo +
      '</p>' +
      '<p class="text-left m-0 "><span>Almacen: </span>' + (data.isCedis ? 'CDMX' : this.getAlmacenPre()) +
      '</p>' +
      '<p class="text-left m-0">Cantidad agregada: <span>' + cantidad +
      '</span></p>' +
      '<div class="product-detail"><div class="info-price"><p class="price text-left m-0">' + this.getPrices(data) +
      '</p></div></div>' +
      '</div>';
    if (data.isCedis) {
      html2 += '<div class="col-12" style="margin: 12px 0 0 0;">' +
        '<div class="actions-item actions-item--tiempo-entrega">' +
        '<div class="row-grid col-grid-1 col-grap-15 row-grid-items-center">' +
        '<div class="row-grid col-grid-1">' +
        '<div class="div__tiempo-estimado--column div--display">' +
        '<div class="div__justify--svg">' +
        '<img src="../../../assets/iconos/icon-alert.svg">' +
        '</div>' +
        '<span class="span--size">El tiempo de entrega para este articulos es de 3 a 5 días hábiles.</span>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>';
    }
    html2 += '</div>';

    /* if (window.innerWidth <= 770) {
      Swal.fire({
        title:
          '<h5 class="card-title text-1rem text-center pt-3 pb-1">' +
          '<span><i class="text-success far fa-check-circle mr-2"></i>' + 'Tu producto se agregó al carrito' +
          '</span></h5>',
        html: html2,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Ver carrito <i class="material-icons">shopping_cart_checkout</i>',
        confirmButtonAriaLabel: 'Thumbs up, great!',
        cancelButtonText: 'Seguir comprando <i class="fas fa-arrow-right ml-2 text-success"></i>',
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#212529',
        customClass: {
          confirmButton: 'd-flex',
          popup: 'swal__addd-cart',
        }
      }).then(result => {
        if (result.value) {
          // this.router.navigate(['/cart']);
          window.location.href = '/cart';
        } else if (result.dismiss) {
          Swal.close();
        }
      });
    }

    else { */

      Swal.fire({
        /* position: 'top-end', */
        type: 'success',
        showCloseButton: true,
        allowOutsideClick: true,
        scrollbarPadding: false,
        heightAuto: false,
        title: 'El producto se agreg\u00F3 al carrito.',
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 2000,
        customClass: {
          icon: 'success-icon-container',
          container: 'purchase-item-container',
        },
        background: '#e7f5e7',
        onOpen: function () {
          document.body.style.overflow = 'auto';
        }
      });
    /* } */

  }





  // este SWAL es para mostrar que el artículo ya existe en la cesta
  public swalArticleInTheCart = (): void => {
    Swal.fire({
      title: '¡Este producto ya está en tu carrito!',
      text: 'Para agregar más piezas ve al carrito de compras.',
      type: 'info',
      focusConfirm: false,
      confirmButtonText: 'Aceptar',
      confirmButtonAriaLabel: 'Thumbs up, great!',
      cancelButtonText: 'Seguir comprando <i class="fas fa-arrow-right ml-2 text-success"></i>',
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#212529',
      customClass: {
        confirmButton: 'btn btn-success d-flex',
        cancelButton: 'btn btn-light',
        popup: 'swal__addd-cart',
      },
    }).then(result => {
      if (result.value) {
        // this.router.navigate(['/cart']);
        Swal.close()
      } else if (result.dismiss) {
        Swal.close();
      }
    });
  }

  // este SWAL es para mostrar que se envío un correo electrónico de recuperación de contraseña
  public swalSuccessRecoverPassWord = (email: string): void => {
    Swal.fire({
      type: 'success',
      title: 'Recuperacion de contraseña',
      text: 'Hemos enviando un correo electronico a ' + email + ' con las instrucciones para restablecer tu contraseña.',
      confirmButtonText: 'Aceptar'
    });
  }


  // este SWAL es para mostrar los mensajes de tipo error
  public swalError = (title: string, text: string): void => {
    Swal.fire({
      type: 'error',
      title,
      html: text,
      confirmButtonColor: '#e52325',
      confirmButtonText: 'Aceptar',
      footer: 'Contáctanos&nbsp;<a href="mailto:incidencias@kabik.com.mx">incidencias@kabik.com.mx</a>'
    });
  }

  // este SWAL es para mostrar los mensajes de tipo advertencia
  public swalAlert = (title: string, text: string, redirect?: boolean, url?: string): void => {
    Swal.fire({
      type: 'warning',
      title,
      html: text,
      confirmButtonColor: '#f79d50',
      confirmButtonText: 'Aceptar',
      footer: 'Contáctanos&nbsp;<a href="mailto:incidencias@kabik.com.mx">incidencias@kabik.com.mx</a>'
    }).then((result) => {
      if (result.value && redirect) {
        this.router.navigate([url]);
      }
    });
  }

  // este SWAL es para mostrar los mensajes de kabicoins
  public swalAlertKbCoin = (title: string, text: string, redirect?: boolean, url?: string, email?: string): void => {
    Swal.fire({
      type: 'warning',
      title,
      html: text,
      confirmButtonColor: '#f79d50',
      confirmButtonText: 'Aceptar',
      footer: 'Contáctanos&nbsp;<a href="mailto:' + email + '">' + email + '</a>'
    }).then((result) => {
      if (result.value && redirect) {
        this.router.navigate([url]);
      }
    });
  }

  // este SWAL es la mostrar los mensajes de tipo información
  public swalInfo = (title: string, text: string): void => {
    Swal.fire({
      type: 'info',
      title,
      html: text,
      confirmButtonColor: '#3fc3ee',
      confirmButtonText: 'Aceptar',
      footer: 'Contáctanos&nbsp;<a href="mailto:incidencias@kabik.com.mx">incidencias@kabik.com.mx</a>',
      customClass: {
        popup: 'swal__addd-cart',
      },
    });
  }

  // este SWAL es para mostrar los mensajes de tipo éxitoso
  public swalSuccess = (title: string, text: string): void => {
    Swal.fire({
      type: 'success',
      title,
      html: text,
      confirmButtonColor: '#00a650',
      confirmButtonText: 'Aceptar',
      footer: 'Contáctanos&nbsp;<a href="mailto:incidencias@kabik.com.mx">incidencias@kabik.com.mx</a>',
      customClass: {
        popup: 'swal__addd-cart',
      },
    });
  }
  private getAlmacenPre = () => {
    const dataUser = this.login.getDataClientePedido();
    if (dataUser.sucursal === 'KABIK NORTE' || dataUser.sucursal === 'Kabik Norte') {
      return 'Tampico';
    }
    return dataUser.sucursal;
  }

  // esta función es para retornar la imágen de un artículo
  private getKeyArticleClean = (key) => {
    let clave = '';
    clave = key.replace('/', '');
    clave = clave.replace('#', '').trim();
    return 'https://api.kabik.mx/imagenes_pagina/Kabik/imagenes_fichas/' + clave + '_1.jpg';
  }
}
